<template>
  <modal
    ref="alertModal"
    v-if="getAlert.Enabled && paylaterSettings.Enabled && !firstTimeCheck"
    :canBeDismissed="false"
  >
    <template slot="header">{{ getAlert.Name || getAlertTitle }}</template>
    <template slot="body">
      <div class="alert-message" v-html="getAlert.Message"></div>
    </template>
    <template slot="footer">
      <button class="btn btn-light" @click="confirm">ok</button>
    </template>
  </modal>
</template>

<script>
import modal from "../modal.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    modal,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(["payLaterNotifications", "paylaterSettings"]),
    getAlert() {
      switch (this.type) {
        case 0:
          return this.payLaterNotifications.FirstTimeAlert;
        case 1:
          return this.payLaterNotifications.CheckoutAlert;
        case 2:
          return this.payLaterNotifications.HighFrequncyAlert;
        case 3:
          return this.payLaterNotifications.WastageAlert;
        case 4:
          return this.payLaterNotifications.DuplicateItemsAlert;
        default:
          return this.payLaterNotifications.FirstTimeAlert;
      }
    },
    getAlertTitle() {
      switch (this.type) {
        case 0:
          return "First Time Alert";
        case 1:
          return "Checkout Alert";
        case 2:
          return "High Frequncy Alert";
        case 3:
          return "Wastage Alert";
        case 4:
          return "Duplicate Items Alert";
        default:
          return "First Time Alert";
      }
    },
    firstTimeCheck() {
      return (
        this.type === 0 &&
        window.sessionStorage.getItem("WastageFirstTimeNotification")
      );
    },
  },
  methods: {
    confirm() {
      this.$refs.alertModal.hideModal(true);
      if (this.type === 0) {
        window.sessionStorage.setItem("WastageFirstTimeNotification", true);
      }
      this.$emit("confirmed");
    },
  },
};
</script>

<style>
.alert-message {
  padding: 0 1rem;
}
</style>
